export default {
  'selector_multiple_component_placeholder': '搜索',
  'selector_multiple_component_overall': '聚合数据',
  'selector_multiple_component_select_all': '全选',
  'selector_multiple_component_clear_all': '清空',
  'selector_multiple_component_no_data': '无匹配项',
  'selector_multiple_component_no': '暂无数据',

  // 自定义筛选器
  'selector_multiple_component_custom_filter_all_describe': '全部',
  // zone
  'selector_multiple_component_zone_label': '区服',
  'selector_multiple_component_zone_all_describe': '全部',
  'selector_multiple_component_zone_all_info': '展示所有区服的去重用户数据',

  // channel
  'selector_multiple_component_channel_label': '渠道',
  'selector_multiple_component_channel_all_describe': '全部',
  'selector_multiple_component_channel_all_info': '展示所有渠道的去重用户数据',
  'selector_multiple_component_channel_all_info_pubgm': 'ALL：展示所有渠道的去重用户数据\n' +
    'TP开头的：台湾版\n' +
    'JPKR开头的：日韩版\n' +
    'VNG开头的：越南版\n' +
    'LITE开头的：Lite版\n' +
    '其他没有固定前缀的：国际版\n' +
    '以上所有去掉Lite版：M版',
  'selector_multiple_component_channel_tips': '玩家登录渠道',
  'selector_multiple_component_channel_tips_iaa': '玩家来源渠道包',

  // system
  'selector_multiple_component_system_label': '平台',
  'selector_multiple_component_system_all_describe': '全部',
  'selector_multiple_component_system_all_info': '展示所有平台的去重用户数据',
  'selector_multiple_component_system_tips': '玩家登录平台',

  // NetWork Type
  'selector_multiple_component_network_label': '网络类型',
  'selector_multiple_component_network_all_describe': '全部',
  'selector_multiple_component_network_all_info': '展示所有网络类型的去重用户数据',

  // Media Channel
  'selector_multiple_component_media_label': '媒体渠道',
  'selector_multiple_component_media_all_describe': '全部',
  'selector_multiple_component_media_all_info': '展示所有媒体渠道的去重用户数据',

  // Language Channel
  'selector_multiple_component_language_label': '语言',
  'selector_multiple_component_language_all_describe': '全部',
  'selector_multiple_component_language_all_info': '展示所有语言的去重用户数据',
  'selector_multiple_component_language_tips': '玩家注册系统语言',


  'selector_multiple_component_language_label_poe': '语言',
  'selector_multiple_component_language_all_info_poe': '展示所有语言的去重用户数据',
  

  // Country
  'selector_multiple_component_country_label': '国家',
  'selector_multiple_component_country_all_describe': '全部',
  'selector_multiple_component_country_all_info': '展示所有国家的去重用户数据',

  // Competitor
  'selector_multiple_component_competitor_label': '竞品',
  'selector_multiple_component_competitor_all_describe': '全部',

  // APP Version
  'selector_multiple_component_app_version_label': 'App版本',
  'selector_multiple_component_app_version_all_describe': '全部',
  'selector_multiple_component_app_version_all_info': '展示所有App版本的去重用户数据',

  // Memory
  'selector_multiple_component_memory_label': '内存',
  'selector_multiple_component_memory_all_describe': '全部',
  'selector_multiple_component_memory_all_info': '展示所有内存的去重用户数据',

  'selector_multiple_component_store_channel_label': '商店渠道',
  'selector_multiple_component_store_channel_all_describe': '全部',
  'selector_multiple_component_store_channel_all_info': '展示所有商店渠道的去重用户数据',

  // Step
  'selector_multiple_component_step_label': '步骤',
  'selector_multiple_component_step_describe': '全部',

  'selector_multiple_component_churn_level_all_info': '展示所有流失等级的去重用户数据',

  
  'selector_multiple_component_common_all_describe': '全部',

  'selector_multiple_component_common_all_info': '展示所有{name}的去重用户数据',
  'selector_multiple_component_metrics_label': '指标',
  'selector_limit_msg':'选择指标已达上限，请先取消不需要的指标。',

  'selector_multiple_component_bundle_label': '渠道包',
}
